export default __webpack_public_path__ + "86942c01f386202f7e3614461033f54c.xlsx";